const EARTH_RADIUS = 6371000

// Tiempo fijo en cada parada que aún no se ha pasado. ponytail: no es el tiempo real de entrega; se cambia este número.
export const STOP_SECONDS = 5 * 60

// ponytail: el driver se pega al tramo más cercano de la ruta guardada. Si se sale del camino, no recalcula con Google.
export function remainingMeters(route, position) {
    const where = locate(route, position)
    if (!where) return null

    let meters = (1 - where.t) * segmentMeters(route, where.points, where.index)

    for (let index = where.index + 1; index < where.points.length - 1; index++)
        meters += segmentMeters(route, where.points, index)

    const total = route.totals && route.totals.distanceMeters
    if (total != null) meters = Math.min(meters, total)

    return Math.max(0, Math.round(meters))
}

export function remainingSeconds(route, position) {
    const where = locate(route, position)
    if (!where) return null

    const driving = driveSeconds(route, position, where)
    if (driving == null) return null

    return Math.max(0, Math.round(driving) + remainingStopCount(route, where) * STOP_SECONDS)
}

function driveSeconds(route, position, where) {
    let seconds = 0

    for (let index = where.index; index < where.points.length - 1; index++) {
        const legSeconds = segmentSeconds(route, index)
        if (legSeconds == null)
            return secondsFromPace(route, remainingMeters(route, position))

        const fraction = index === where.index ? 1 - where.t : 1
        seconds += fraction * legSeconds
    }

    const total = route.totals && route.totals.durationSeconds
    if (total != null) seconds = Math.min(seconds, total)

    return seconds
}

function remainingStopCount(route, where) {
    const hasStart = route.start && route.start.lat != null
    const hasEnd = route.end && route.end.lat != null
    const firstStop = hasStart ? 1 : 0
    const lastStop = where.points.length - 1 - (hasEnd ? 1 : 0)
    let from = where.index + 1

    if (where.t === 0 && where.index >= firstStop && where.index <= lastStop)
        from = where.index

    from = Math.max(from, firstStop)
    if (from > lastStop) return 0

    return lastStop - from + 1
}

function locate(route, position) {
    if (!route || !position || position.lat == null || position.lng == null) return null

    const points = routePoints(route)
    if (points.length < 2) return null

    let nearest = null

    for (let index = 0; index < points.length - 1; index++) {
        const projected = project(points[index], points[index + 1], position)
        const distance = haversine(position, projected.point)
        if (!nearest || distance < nearest.distance)
            nearest = { index, t: projected.t, distance }
    }

    return { points, index: nearest.index, t: nearest.t }
}

function routePoints(route) {
    const points = []

    if (route.start && route.start.lat != null) points.push(route.start)

    for (const stop of route.stops || []) {
        if (stop.position && stop.position.lat != null) points.push(stop.position)
    }

    if (route.end && route.end.lat != null) points.push(route.end)

    return points
}

function segmentMeters(route, points, index) {
    const leg = route.legs && route.legs[index]
    if (leg && leg.distanceMeters != null) return leg.distanceMeters
    return haversine(points[index], points[index + 1])
}

function segmentSeconds(route, index) {
    const leg = route.legs && route.legs[index]
    if (!leg || leg.durationSeconds == null) return null
    return leg.durationSeconds
}

function secondsFromPace(route, meters) {
    if (meters == null) return null

    const totalMeters = route.totals && route.totals.distanceMeters
    const totalSeconds = route.totals && route.totals.durationSeconds
    if (totalMeters == null || totalSeconds == null || totalMeters <= 0) return null

    return Math.max(0, Math.round(Math.min(totalSeconds, meters * totalSeconds / totalMeters)))
}

function project(start, end, position) {
    const dx = end.lng - start.lng
    const dy = end.lat - start.lat
    const length = dx * dx + dy * dy
    if (!length) return { t: 0, point: start }

    const t = Math.max(0, Math.min(1, ((position.lng - start.lng) * dx + (position.lat - start.lat) * dy) / length))

    return {
        t,
        point: { lat: start.lat + dy * t, lng: start.lng + dx * t },
    }
}

function haversine(start, end) {
    const dLat = rad(end.lat - start.lat)
    const dLng = rad(end.lng - start.lng)
    const h = Math.sin(dLat / 2) ** 2
        + Math.cos(rad(start.lat)) * Math.cos(rad(end.lat)) * Math.sin(dLng / 2) ** 2

    return 2 * EARTH_RADIUS * Math.asin(Math.min(1, Math.sqrt(h)))
}

function rad(value) {
    return value * Math.PI / 180
}
